import { ApiError, queryClient } from 'src/config/request'
import { toastEventDispatch } from '@hotmart/space-lib-events/dist/toast'
import { ToastPosition, ToastType } from '@hotmart/space-lib-events/dist/toast/enum'
import useScheduledPostsPublishNow from 'src/hook/useScheduledPostsPublishNow'
import useSendDataHubConsume from 'src/hook/useSendDatahubConsume/useSendDatahubConsume'
import i18n from 'src/i18n'
import { useUser } from 'src/hook/useUser'
import { useCommunityDetails } from 'src/pages/CommunityDetails/Posts/context/communityDetailsContext'
import {
  Actions,
  Entities,
  EventNames,
  ResultType,
  ResultsTypes,
  ScreenNames
} from 'src/utils/datahub/enums'
import { UsePublishSchedulePostProps } from './usePublishSchedulePost.types'

const usePublishSchedulePost = ({ postId }: UsePublishSchedulePostProps) => {
  const { mutate } = useScheduledPostsPublishNow()
  const { sendDataHubConsume } = useSendDataHubConsume()
  const { user } = useUser()
  const { community } = useCommunityDetails()

  const sendTrackEvent = (result: ResultType, failureKind?: string) => {
    sendDataHubConsume({
      action: Actions.POST,
      entity: Entities.SCHEDULED_POST,
      event: {
        screenName: ScreenNames.SCHEDULED_ACTIONS,
        eventName: EventNames.TRY_TO_POST_A_SCHEDULED_POST,
        user: {
          id: user.id,
          name: user.name
        },
        community: {
          id: community.id,
          name: community.name
        },
        result,
        failureKind
      }
    })
  }

  const onPublish = () => {
    mutate(postId, {
      onSuccess() {
        queryClient.invalidateQueries(['getScheduledPosts'])

        toastEventDispatch({
          type: ToastType.SUCCESS,
          message: i18n.t('notifications.schedule.success'),
          position: ToastPosition.BOTTOM_RIGHT
        })

        sendTrackEvent(ResultsTypes.SUCCESS)
      },
      onError(err) {
        toastEventDispatch({
          type: ToastType.DANGER,
          message: i18n.t('notifications.schedule.error'),
          position: ToastPosition.BOTTOM_RIGHT
        })

        sendTrackEvent(ResultsTypes.FAILURE, (err as ApiError)?.message)
      }
    })
  }

  return { onPublish }
}

export default usePublishSchedulePost
